import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const header = css`
  display: flex;
  flex-direction: column;
  margin-bottom: clamp(${size[32]}, 3vw + ${size[16]}, ${size[64]});
  gap: clamp(${size[20]}, 3vw + ${size[12]}, ${size[40]});
`

export const main = css`
  *:last-child {
    margin-bottom: ${size[0]};
  }
`

export const article = css`
  html {
    scroll-behavior: smooth;
  }
`
